import { apolloClient } from '@/modules/myStageGraphQL';
import { VALIDATE_SALES_TRIAL_CREDENTIALS, SALES_TRIAL_LESSON_LIST } from '@/graphql/salesTrial';
import { CREATE_SALES_TRIAL_LESSON } from '@/graphql/mutations/salesTrial';
import { mystageServiceIdHeaderName } from '@/utils/constants';

export default {
  namespaced: true,
  state() {
    return {
      serviceId: null,
      pageUrl: null,
      trialLessonLoginSuccess: false,
      trialLessonCredentials: {
        companyName: null,
        email: null,
        expirationDate: null,
        id: null,
        valid: null
      },
      trialLessonLists: null,
      isTrialLessonCreated: false
    };
  },
  mutations: {
    setServiceId(state, serviceId) {
      state.serviceId = serviceId;
    },
    getPageUrl(state, pageUrl) {
      state.pageUrl = pageUrl;
    },
    setTrialLessonCredentials(state, payload) {
      state.trialLessonCredentials = payload;
    },
    setTrialLessonLists(state, payload) {
      state.trialLessonLists = payload;
    },
    setTrialLessonLoginSuccess(state, success) {
      state.trialLessonLoginSuccess = success;
    },
    setTrialLessonCreated(state, success) {
      state.isTrialLessonCreated = success;
    }
  },
  actions: {
    setServiceId({ commit }, serviceId) {
      commit('setServiceId', serviceId);
    },
    getPageUrl({ commit }, pageUrl) {
      commit('getPageUrl', pageUrl);
    },
    setTrialLessonLoginSuccess({ commit }, success) {
      commit('setTrialLessonLoginSuccess', success);
    },
    async authenticateUser({ commit, state }, user) {
      const { data } = await apolloClient.query({
        query: VALIDATE_SALES_TRIAL_CREDENTIALS,
        variables: {
          email: user.email,
          code: user.code,
          page_url: user.page_url
        },
        context: {
          authRequired: false,
          headers: {
            [mystageServiceIdHeaderName]: state.serviceId
          }
        },
        fetchPolicy: 'no-cache'
      });
      commit('setTrialLessonCredentials', data.validateSalesTrialCredentials);
    },
    async createLesson({ commit, state }, user) {
      try {
        const { data } = await apolloClient.mutate({
          mutation: CREATE_SALES_TRIAL_LESSON,
          variables: {
            page_url: user.page_url,
            code: user.code,
            email: user.email
          },
          context: {
            authRequired: false,
            headers: {
              [mystageServiceIdHeaderName]: state.serviceId
            }
          }
        });

        const success = !!(data?.createSalesTrialLesson?.id);
        commit('setTrialLessonCreated', success);
      } catch (error) {
        commit('setTrialLessonCreated', false);
        throw error;
      }
    },
    async getTrialLessonLists({ commit }, { page_url, code, email, serviceId }) {
      const { data } = await apolloClient.query({
        query: SALES_TRIAL_LESSON_LIST,
        variables: { page_url, code, email },
        context: {
          authRequired: false,
          headers: {
            [mystageServiceIdHeaderName]: serviceId
          }
        },
        fetchPolicy: 'no-cache'
      });
      commit('setTrialLessonLists', data.salesTrialLessonList.items);
    }
  }
};
